export var CHANGE_PAGE = 'REDUX_ROUTER.CHANGE_PAGE';
export function changePage(name, params) {
  var action = {
    type: CHANGE_PAGE
  };
  var payload = {
    name: name
  };

  if (params != null) {
    payload.params = params;
  }

  action.payload = payload;
  return action;
}
export function pageSelector(state, basePath) {
  return state[basePath];
}
export function reducer() {
  var _action$payload;

  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case CHANGE_PAGE:
      return (_action$payload = action.payload) !== null && _action$payload !== void 0 ? _action$payload : null;

    default:
      return state;
  }
}